import React, { useState, useEffect, useRef } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";
import Select from "react-select";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import ArModal from "../../../components/Modal/ArModal";
import ItemTable from "../../../components/Content/ItemTable";
import Summary from "../../../components/Footer/Summary";
import FormAction from "../../../components/Actions/FormAction";

// Model
import { qtMasterModel } from "../../../../model/SellProducts/QtMasterModel";
import { qtDetailModel } from "../../../../model/SellProducts/QtDetailModel";

// Utils
import {
  getDataWithComp,
  getData,
  getByDocId,
  getDocType,
  getTransType,
  // getViewAp,
  getViewItem,
  getAlert,
  formatCurrency,
  parseCurrency,
  getMaxDocNo,
  deleteData,
  randomDelay,
  updateData,
  insertData,
} from "../../../../utils/SamuiUtils";

import {
  formatStringDateToDate,
  formatDateOnChange,
  formatDateTime,
  formatThaiDateUi,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
} from "../../../../utils/DateUtils";
import Swal from "sweetalert2";

function Form({
  callInitialize,
  mode,
  name,
  maxDocNo,
  getReport,
  setMaxDocNo,
  setMode,
}) {
  const [formMasterList, setFormMasterList] = useState(qtMasterModel());
  // console.log("formMasterList", formMasterList);
  const [formDetailList, setFormDetailList] = useState([]);
  // console.log("formDetailList", formDetailList);
  const [tbDocType, setTbDocType] = useState([]);
  const [tbTransType, setTbTransType] = useState([]);
  const [arDataList, setArDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);
  const [arContactlist, setARContactlist] = useState([]);

  // Revise Modal
  const [showReviseModal, setShowReviseModal] = useState(false);
  const [reviseLog, setReviseLog] = useState([]);
  const [showDetailReviseModal, setShowDetailReviseModal] = useState(false);
  const [detailReviseHeader, setDetailReviseHeader] = useState([]);
  const [detailReviseList, setDetailReviseList] = useState([]);

  // Edit Revise
  const [editRevise, setEditRevise] = useState(false);

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(true);
  const [vatAmount, setVatAmount] = useState(0);
  const [contactID, setContactID] = useState();

  // การแสดงสถานะใบ
  const [statusName, setStatusName] = useState("");
  const [statusColour, setStatusColour] = useState("");

  // สำหรับส่งไปหน้า FormAction
  // const [docStatus, setDocStatus] = useState(null);
  const [whid, setWhid] = useState(0);
  const [loading, setLoading] = useState(false);

  const onHandCacheRef = useRef(new Map()); // key: `${whId}:${itemId}` => number
  const bomListCacheRef = useRef(new Map()); // key: `${parentId}` => array

  const initialize = async () => {
    setLoading(true);
    try {
      const [
        docTypeList,
        transTypeList,
        arDataList,
        itemDataList,
        whDataList,
        setwh,
      ] = await Promise.all([
        getDocType(2),
        getTransType(),
        getDataWithComp("Tb_Set_AR", "ORDER BY AR_Code ASC"),
        getViewItem(),
        getDataWithComp(
          "Tb_Set_Wh",
          "AND Flag_Vansale = 'N' AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC"
        ),
        getDataWithComp("Tb_Set_WH", "and WH_Default_Sale = 'Y'"),
      ]);

      if (docTypeList?.length > 0) setTbDocType(docTypeList);
      if (transTypeList?.length > 0) setTbTransType(transTypeList);
      if (arDataList?.length > 0) setArDataList(arDataList);
      if (itemDataList?.length > 0) {
        setItemDataList(itemDataList);
      }
      if (whDataList?.length > 0) setWhDataList(whDataList);
      if (setwh?.length > 0) setWhid(setwh.at(0).WH_Id);

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล - ส่ง itemDataList ไปด้วย
      if (mode === "U" || mode === "R") {
        await getModelByNo(arDataList, itemDataList);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    } finally {
      setLoading(false);
    }
  };

  const getModelByNo = async (arDataList, itemDataListParam) => {
    try {
      // ดึงข้อมูลเอกสารจาก QT_H โดยใช้ WHERE clause เพื่อประสิทธิภาพ
      const findMaster = await getData("QT_H", `Doc_No = '${maxDocNo}'`);
      const fromDatabase = findMaster.find((ar) => ar.Doc_No === maxDocNo);

      if (!fromDatabase) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายด้วย AR_ID
      const fromViewAr = arDataList.find(
        (ar) => ar.AR_Id === fromDatabase.AR_ID
      );

      if (!fromViewAr) {
        throw new Error("ไม่พบข้อมูลลูกค้า");
      }

      const arContact_list = await getData(
        "Tb_Set_ARContact",
        `ar_id = ${fromDatabase.AR_ID}`
      );
      if (arContact_list.length > 0) {
        const mapped = arContact_list.map((item) => ({
          id: item.id,
          contactName: item.contact_name,
          contactEmail: item.contact_email,
          contactPhone: item.contact_telephone,
        }));

        // 1. เซ็ต arContactlist ก่อน
        setARContactlist(mapped);

        // 2. ใช้ setTimeout หรือ await Promise.resolve() เพื่อให้ state อัปเดตทันก่อน
        setTimeout(() => {
          const selectedContact = mapped.find(
            (contact) => contact.contactName === fromDatabase.Contact_Name
          );
          if (selectedContact) {
            setContactID(selectedContact.id);
          }
        }, 0);
      }

      // SET สถานะใช้กับ FormAction (ไม่ใช้ state แยกแล้ว)

      // ค้นหาข้อมูล VIEW โดยใช้ WHERE clause เฉพาะเอกสารนี้
      const findViewMaster = await getData("API_0601_QT_H", `Doc_No = '${maxDocNo}'`);
      const fromView = findViewMaster.find((data) => data.Doc_No === maxDocNo);
      setStatusName(fromView.DocStatus_Name);
      setStatusColour(fromView.DocStatus_Colour);

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        const itemDisType = String(itemSelected.Item_DisType);
        let itemTotal = itemQty * itemPriceUnit;

        if (itemDisType === "2") {
          itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
        } else {
          itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
        }

        // ดึงจาก itemDataListParam เพื่อดูว่าเป็น Project ไหม
        const matchedItem = itemDataListParam.find(
          (i) => i.Item_Id === itemSelected.Item_Id
        );
        const isProjectItem =
          matchedItem?.Item_Group === 3 || matchedItem?.Is_BOM === "Y";

        //  เช็คว่าเป็น BOM ลูกหรือเปล่า (Item_Code = "BOM" หรือ Item_Code = "" และ ราคา = 0)
        const isBOMChild =
          itemSelected.Item_Code === "BOM" ||
          (!itemSelected.Item_Code && itemPriceUnit === 0);

        //  เช็คว่าเป็น Spec row หรือเปล่า (Item_Code = "" และ Item_Id = null)
        const isSpecRow =
          !itemSelected.Item_Code &&
          !itemSelected.Item_Id &&
          itemSelected.Item_Name;

        //  หา parentId สำหรับ BOM children และ Spec rows
        let parentId = null;
        if (isBOMChild || isSpecRow) {
          // หา parent item ที่อยู่ก่อนหน้า (ในข้อมูล fromDetail)
          for (let i = index - 1; i >= 0; i--) {
            const prevItem = fromDetail[i];

            // ตรวจสอบว่า prevItem มี Item_Id และไม่ใช่ BOM child หรือ Spec row
            if (
              prevItem &&
              prevItem.Item_Id &&
              prevItem.Item_Code &&
              prevItem.Item_Code !== "BOM"
            ) {
              const prevMatchedItem = itemDataListParam.find(
                (itm) => itm.Item_Id === prevItem.Item_Id
              );

              // หาก parent เป็น Project item (มี BOM หรือ Spec) หรือเป็น item ปกติ
              if (prevMatchedItem) {
                parentId = prevItem.Item_Id;
                break;
              }
            }
          }

          // ถ้าไม่เจอ parent ให้ดูจาก item ก่อนหน้าโดยตรง
          if (!parentId && index > 0) {
            const directPrevItem = fromDetail[index - 1];
            if (
              directPrevItem &&
              directPrevItem.Item_Id &&
              directPrevItem.Item_Code &&
              directPrevItem.Item_Code !== "BOM"
            ) {
              parentId = directPrevItem.Item_Id;
            }
          }
        }

        return {
          ...qtDetailModel(index + 1),
          dtId: itemSelected.DT_Id,
          docId: itemSelected.Doc_ID,
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit),
          itemDiscount: formatCurrency(itemDiscount),
          itemDisType,
          itemTotal,
          itemStatus: itemSelected.Item_Status,
          whName: itemSelected.WH_Name,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
          isProjectItem: isProjectItem || false,
          isBOMChild: isBOMChild || false, // ✅ เพิ่ม flag
          isSpecRow: isSpecRow || false, // ✅ เพิ่ม flag
          parentId: parentId, // ✅ เพิ่ม parentId
        };
      };

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromDetail = await getByDocId(
        "QT_D",
        fromDatabase.Doc_Id,
        `ORDER BY Line ASC`
      );
      if (fromDetail.length > 0) {
        const newFormDetails = fromDetail.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );
        setFormDetailList(newFormDetails);
        // console.debug("dfhjghd", fromDatabase.Payment_Text2);
        setFormMasterList({
          docId: fromDatabase.Doc_Id,
          docNo: fromDatabase.Doc_No,
          docDate:
            mode === "R"
              ? formatThaiDateUi(moment().format("YYYY-MM-DD"))
              : formatThaiDateUi(fromDatabase.Doc_Date || null),

          docDueDate:
            mode === "R"
              ? formatThaiDateUi(moment().format("YYYY-MM-DD"))
              : formatThaiDateUi(fromDatabase.Doc_DueDate || null),
          docStatus: fromDatabase.Doc_Status,
          docCode: fromDatabase.Doc_Code,
          docType: fromDatabase.Doc_Type,
          docFor: fromDatabase.Doc_For,
          docIsPO: fromDatabase.Doc_Is_PO,
          refDocID: fromDatabase.Ref_DocID,
          refDoc: fromDatabase.Ref_Doc,
          refDocDate: fromDatabase.Ref_DocDate,
          compId: fromDatabase.Comp_Id,
          refProjectID: fromDatabase.Ref_ProjectID,
          refProjectNo: fromDatabase.Ref_ProjectNo,
          transportType: fromDatabase.Transport_Type,
          docRemark1: fromDatabase.Doc_Remark1,
          docRemark2: fromDatabase.Doc_Remark2,
          arID: fromDatabase.AR_ID,
          arCode: fromDatabase.AR_Code,
          actionHold: fromDatabase.Action_Hold,
          discountValue: fromDatabase.Discount_Value,
          discountValueType: fromDatabase.Discount_Value_Type,
          discountCash: fromDatabase.Discount_Cash,
          discountCashType: fromDatabase.Discount_Cash_Type,
          discountTransport: fromDatabase.Discount_Transport,
          discountTransportType: fromDatabase.Discount_Transport_Type,
          isVat: fromDatabase.IsVat,
          docSEQ: fromDatabase.Doc_SEQ,
          creditTerm: fromDatabase.CreditTerm,
          creditTerm1Day: fromDatabase.CreditTerm1Day,
          creditTerm1Remark: fromDatabase.CreditTerm1Remark,
          creditTerm2Remark: fromDatabase.CreditTerm2Remark,
          accCode: fromDatabase.ACC_Code,
          empName: fromDatabase.EmpName,
          createdDate: setCreateDateTime(fromDatabase.Created_Date || null),
          createdByName: fromDatabase.Created_By_Name,
          createdById: fromDatabase.Created_By_Id,
          updateDate: setCreateDateTime(fromDatabase.Update_Date || null),
          updateByName: fromDatabase.Update_By_Name,
          updateById: fromDatabase.Update_By_Id,
          approvedDate: setCreateDateTime(fromDatabase.Approved_Date || null),
          approvedByName: fromDatabase.Approved_By_Name,
          approvedById: fromDatabase.Approved_By_Id,
          cancelDate: setCreateDateTime(fromDatabase.Cancel_Date || null),
          cancelByName: fromDatabase.Cancel_By_Name,
          cancelById: fromDatabase.Cancel_By_Id,
          approvedMemo: fromDatabase.Approved_Memo,
          printedStatus: fromDatabase.Printed_Status,
          printedDate: setCreateDateTime(fromDatabase.Printed_Date || null),
          printedBy: fromDatabase.Printed_By,

          // ข้อมูลลูกค้า
          arName: fromViewAr.AR_Name,
          arAdd1: fromViewAr.AR_Add1,
          arAdd2: fromViewAr.AR_Add2,
          arAdd3: fromViewAr.AR_Add3,
          arProvince: fromViewAr.AR_Province,
          arZipcode: fromViewAr.AR_Zipcode,
          arTaxNo: fromViewAr.AR_TaxNo,
          saleman: fromViewAr.AR_RefSaleName,
          phone: fromViewAr.AR_RefSalePhone,
          delivery: fromDatabase.Delivery_to,
          validityDay: fromDatabase.Validity_day,
          payment: fromDatabase.Payment_text,
          contact_name: fromDatabase.Contact_Name,
          contact_telephone: fromDatabase.Contact_Telephone,
          contact_email: fromDatabase.Contact_Email,
          payment2: fromDatabase.Payment_Text2,
          Doc_Rev: fromDatabase.Doc_Rev,
          cc: fromDatabase.Ref_CC,
        });

        setIsVatChecked(fromDatabase.IsVat === 1);

        const discountValueType = parseCurrency(
          fromDatabase.Discount_Value_Type
        );
        if (!isNaN(discountValueType)) {
          setSelectedDiscountValueType(discountValueType.toString());
        }
      } else {
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const handleCheckboxChange = (e) => {
    setSelectedDiscountValueType(e.target.value); // ค่า "1" หรือ "2"
  };

  const handleSubmit = async () => {
    try {
      await randomDelay();

      // หาค่าสูงสุดของ DocNo
      const findMaxDocNo = await getDataWithComp(
        "QT_H",
        "ORDER BY Doc_Id DESC"
      );
      const maxDoc = getMaxDocNo(findMaxDocNo, "QT");
      let newMaxDoc = maxDoc;

      if (!formMasterList.arID && !formMasterList.arCode) {
        getAlert("FAILED", "กรุณาเลือกผู้ขาย");
        return;
      }

      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return;
      }

      for (const item of formDetailList) {
        if (item.itemCode && item.itemCode !== "-") {
          if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
            getAlert(
              "FAILED",
              `กรุณากรอกจำนวนของสินค้า ${item.itemName || "ที่ไม่มีชื่อ"}`
            );
            return;
          }
          if (
            !item.isProjectItem &&
            !item.isBOMChild &&
            (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0)
          ) {
            getAlert(
              "FAILED",
              `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName || "ที่ไม่มีชื่อ"
              }`
            );
            return;
          }
        }
      }

      if (!contactID && arContactlist.length > 0) {
        const firstContact = arContactlist[0];
        setContactID(firstContact.id);
        setFormMasterList((prev) => ({
          ...prev,
          contact_name: firstContact.contactName,
          contact_telephone: firstContact.contactPhone,
          contact_email: firstContact.contactEmail,
        }));
      }
      const formMasterData = {
        doc_no: newMaxDoc,
        doc_date: formatStringDateToDate(formMasterList.docDate),
        doc_due_date: formatStringDateToDate(formMasterList.docDueDate),
        doc_status: 2,
        doc_code: parseInt("1", 10),
        doc_type: parseInt(formMasterList.docType, 10),
        doc_for: formMasterList.docFor,
        doc_is_po: parseInt("0", 10),
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_doc_date: formMasterList.refDocDate,
        comp_id: window.localStorage.getItem("company"),
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ar_id: parseInt(formMasterList.arID, 10),
        ar_code: formMasterList.arCode,
        action_hold: parseInt("0", 10),
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseInt(
          formMasterList.discountValueType || selectedDiscountValueType,
          10
        ),
        discount_cash: parseCurrency("0.00"),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseCurrency("0.00"),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseInt("1", 10) : parseInt("2", 10),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseInt(formMasterList.creditTerm, 10),
        credit_term_1_day: parseInt("0", 10),
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: "0000",
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: window.localStorage.getItem("name"),
        created_by_id: window.localStorage.getItem("emp_id"),
        update_date: null,
        update_by_name: null,
        update_by_id: null,
        approved_date: null,
        approved_by_name: null,
        approved_by_id: null,
        cancel_date: null,
        cancel_by_name: null,
        cancel_by_id: null,
        approved_memo: null,
        printed_status: "N",
        printed_date: null,
        printed_by: null,
        saleman: formMasterList.saleman,
        phone: formMasterList.phone,
        delivery: formMasterList.delivery,
        validityDay: formMasterList.validityDay,
        payment: formMasterList.payment,
        contact_name: formMasterList.contact_name,
        contact_email: formMasterList.contact_email,
        contact_telephone: formMasterList.contact_telephone,
        payment2: formMasterList.payment2,
        ref_cc: formMasterList.cc,
      };

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-qt-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (response.data.status === "OK") {
        const getDocIdResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-by-doc-no`,
          {
            table: "QT_H",
            doc_no: formMasterData.doc_no,
            comp_id: window.localStorage.getItem("company"),
          },
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        if (getDocIdResponse && getDocIdResponse.data.length > 0) {
          const docId = parseInt(getDocIdResponse.data[0].Doc_Id, 10);
          let index = 1;

          const detailPromises = formDetailList.map(async (item) => {
            const formDetailData = {
              doc_id: docId,
              line: index,
              item_id: item.itemId || null,
              item_code:
                item.itemCode === "BOM" || item.isSpecRow ? "" : item.itemCode,
              item_name: item.itemName || "ไม่ระบุ",
              item_qty: item.isSpecRow ? 0 : parseCurrency(item.itemQty),
              item_unit: item.isSpecRow ? "" : item.itemUnit || "-",
              item_price_unit: item.isSpecRow
                ? 0
                : parseCurrency(item.itemPriceUnit),
              item_discount: item.isSpecRow
                ? 0
                : parseCurrency(item.itemDiscount),
              item_distype: item.isSpecRow
                ? 1
                : item.itemDisType === "1"
                  ? 1
                  : 2,
              item_total: item.isSpecRow
                ? 0
                : parseCurrency(
                  item.itemDisType === "2"
                    ? parseCurrency(item.itemQty) *
                    parseCurrency(item.itemPriceUnit) -
                    (parseCurrency(item.itemDiscount) / 100) *
                    (parseCurrency(item.itemQty) *
                      parseCurrency(item.itemPriceUnit))
                    : parseCurrency(item.itemQty) *
                    parseCurrency(item.itemPriceUnit) -
                    parseCurrency(item.itemDiscount)
                ),
              item_status: 1,
              lt_id: 1,
              ds_seq: formatDateTime(new Date()),
            };
            index++;
            return Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-qt-d`,
              formDetailData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          });

          await Promise.all(detailPromises);
        }
        await Axios.post(
          "/api/memo2text",
          {
            Comp_name: "ENCOT",
            Comp_id: parseInt(localStorage.getItem("company"), 10),
            Prod_uat: process.env.REACT_APP_PROD_UAT,
            Doc_type: "QT",
            Doc_no: formMasterData.doc_no,
            Status: "Save",
          },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    try {
      if (editRevise) {
        handleRevise();

        return;
      }
      // ตรวจสอบค่า formMasterList.arID และ formMasterList.arCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        getAlert("FAILED", "กรุณาเลือกลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (item.itemCode && item.itemCode !== "-") {
          if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
            getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
            return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
          }
          if (
            !item.isProjectItem &&
            !item.isBOMChild &&
            (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0)
          ) {
            getAlert(
              "FAILED",
              `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`
            );
            return;
          }
        }

        // if (!item.whId || parseInt(item.whId) === 13) {
        //     getAlert("FAILED", `กรุณาเลือกคลังสินค้าของสินค้า ${item.itemName}`);
        //     return; // หยุดการทำงานหาก whId เป็น 13 หรือไม่มีค่า
        // }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_date: formatStringDateToDate(formMasterList.docDate),
        doc_due_date: formatStringDateToDate(formMasterList.docDueDate),

        doc_status: parseInt(formMasterList.docStatus, 10),
        doc_code: parseInt(formMasterList.docCode, 10),
        doc_type: formMasterList.docType,
        doc_for: formMasterList.docFor,
        doc_is_po: parseInt(formMasterList.docIsPO, 10),
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_doc_date: formMasterList.refDocDate,
        comp_id: formMasterList.compId,
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ar_id: parseInt(formMasterList.arID, 10),
        ar_code: formMasterList.arCode,
        action_hold: parseInt(formMasterList.actionHold, 10),
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseInt(formMasterList.discountValueType, 10),
        discount_cash: parseCurrency(formMasterList.discountCash),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseCurrency(formMasterList.discountTransport),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseInt("1", 10) : parseInt("2", 10),
        doc_seq: formMasterList.docSEQ,
        credit_term: parseInt(formMasterList.creditTerm, 10),
        credit_term_1_day: parseInt("0", 10),
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: formMasterList.accCode,
        emp_name: formMasterList.empName,
        created_date:
          mode === "R"
            ? formatThaiDateUiToDate(getCreateDateTime())
            : formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name:
          mode === "R"
            ? window.localStorage.getItem("name")
            : formMasterList.createdByName,
        created_by_id:
          mode === "R"
            ? window.localStorage.getItem("emp_id")
            : formMasterList.createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        approved_date: formatThaiDateUiToDate(formMasterList.approvedDate),
        approved_by_name: formMasterList.approvedByName,
        approved_by_id: formMasterList.approvedById,
        cancel_date: formatThaiDateUiToDate(formMasterList.cancelDate),
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        approved_memo: formMasterList.approvedMemo,
        printed_status: formMasterList.printedStatus,
        printed_date: formatThaiDateUiToDate(formMasterList.printedDate),
        printed_by: formMasterList.printedBy,
        saleman: formMasterList.saleman,
        phone: formMasterList.phone,
        delivery: formMasterList.delivery,
        validityDay: formMasterList.validityDay,
        payment: formMasterList.payment,
        contact_name: formMasterList.contact_name,
        contact_email: formMasterList.contact_email,
        contact_telephone: formMasterList.contact_telephone,
        payment2: formMasterList.payment2,
        ref_cc: formMasterList.cc,
      };
      // For Log PR_H
      // console.log("formMasterData : ", formMasterData);

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-qt-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );
      if (mode === "R") {
        if (formMasterList.Doc_Rev === null) {
          formMasterList.Doc_Rev = 0;
        }
        const newRev = parseInt(formMasterList.Doc_Rev ?? 0, 10) + 1;
        await updateData(
          "QT_H",
          { Doc_Rev: newRev },
          { Doc_Id: formMasterList.docId }
        );
      }

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
        await deleteData("QT_D", `WHERE Doc_ID = ${formMasterList.docId}`);

        const docId = parseInt(formMasterList.docId, 10);
        let index = 1;

        const detailPromises = formDetailList.map(async (item) => {
          const formDetailData = {
            doc_id: docId,
            line: index,
            item_id: item.itemId || null,
            item_code:
              item.itemCode === "BOM" || item.isSpecRow ? "" : item.itemCode,
            item_name: item.itemName || "ไม่ระบุ",
            item_qty: item.isSpecRow ? 0 : parseCurrency(item.itemQty),
            item_unit: item.isSpecRow ? "" : item.itemUnit || "-",
            item_price_unit: item.isSpecRow
              ? 0
              : parseCurrency(item.itemPriceUnit),
            item_discount: item.isSpecRow
              ? 0
              : parseCurrency(item.itemDiscount),
            item_distype: item.isSpecRow
              ? 1
              : item.itemDisType === "1"
                ? 1
                : 2,
            item_total: item.isSpecRow
              ? 0
              : parseCurrency(
                item.itemDisType === "2"
                  ? parseCurrency(item.itemQty) *
                  parseCurrency(item.itemPriceUnit) -
                  (parseCurrency(item.itemDiscount) / 100) *
                  (parseCurrency(item.itemQty) *
                    parseCurrency(item.itemPriceUnit))
                  : parseCurrency(item.itemQty) *
                  parseCurrency(item.itemPriceUnit) -
                  parseCurrency(item.itemDiscount)
              ),
            item_status: 1,
            lt_id: 1,
            ds_seq: formatDateTime(new Date()),
          };
          index++;
          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-qt-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        await Promise.all(detailPromises);

        await Axios.post(
          "/api/memo2text",
          {
            Comp_name: "ENCOT",
            Comp_id: parseInt(localStorage.getItem("company"), 10),
            Prod_uat: process.env.REACT_APP_PROD_UAT,
            Doc_type: "QT",
            Doc_no: formMasterData.doc_no,
            Status: "Save",
          },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        );
        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseInt("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
      };

      // For Log PR_H
      // console.log("formMasterData : ", formMasterData);

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-qt-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // handleChangeMasterContact: removed unused handler

  const handleChangeDateMaster = (value, name) => {
    // ตรวจสอบว่า value เป็น moment object หรือไม่
    const newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;

    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: formatDateOnChange(newValue),
    }));
  };

  const handleChangeDetail = async (index, field, value) => {
    const numericFields = ["itemQty", "itemPriceUnit", "itemDiscount"];
    if (numericFields.includes(field) && !/^\d*\.?\d*$/.test(value)) {
      return;
    }

    let updatedList = [...formDetailList];
    updatedList[index][field] = value;

    if (field === "whId") {
      updatedList[index].itemOnHand = "-";

      const newItemOnHand = await fetchOnHand(value, updatedList[index].itemId);

      const itemQty = parseFloat(updatedList[index].itemQty) || 0;
      if (itemQty > newItemOnHand) {
        updatedList[index].itemQty = formatCurrency("0.00");
      }

      updatedList[index].itemOnHand = newItemOnHand;
    }

    if (numericFields.includes(field) || field === "itemQty") {
      const itemQty = parseFloat(updatedList[index].itemQty) || 0;
      const itemPriceUnit =
        parseFloat(parseCurrency(updatedList[index].itemPriceUnit)) || 0;
      const itemDiscount =
        parseFloat(parseCurrency(updatedList[index].itemDiscount)) || 0;
      const itemDisType = String(updatedList[index].itemDisType);

      let itemTotal = itemQty * itemPriceUnit;

      if (itemDisType === "2") {
        itemTotal -= (itemDiscount / 100) * itemTotal;
      } else {
        itemTotal -= itemDiscount;
      }

      updatedList[index].itemTotal = itemTotal;

      // ✅ ถ้าเป็น Project (Group 3 / หัวโปรเจกต์) → กระจาย qty ไปยังลูก BOM
      // if (updatedList[index].isProjectItem === true) {
      //   const parentId = updatedList[index].itemId;

      //   const bomList = await getDataWithComp(
      //     "Tb_Set_ItemBOM",
      //     `AND pro_id = ${parentId}`
      //   );

      //   updatedList = updatedList.map((item) => {
      //     if (item.itemId === parentId) return item;

      //     const bomItem = bomList.find((b) => b.item_id === item.itemId);
      //     if (bomItem) {
      //       const newQty =
      //         parseCurrency(bomItem.quantity || 0) * parseCurrency(itemQty);
      //       return {
      //         ...item,
      //         itemQty: formatCurrency(newQty),
      //         itemTotal: 0, // ให้ user กรอกราคาหรือคำนวณเองภายหลัง
      //       };
      //     }
      //     return item;
      //   });
      // }
    }

    setFormDetailList(updatedList);
  };

  const handleFocus = (index, field) => {
    const updatedList = [...formDetailList];
    const value = updatedList[index][field];

    let parsed = 0;

    if (typeof value === "string") {
      parsed = parseCurrency(value.replace(/,/g, ""));
    } else if (typeof value === "number") {
      parsed = value;
    } else if (value != null && typeof value.toString === "function") {
      parsed = parseCurrency(value.toString().replace(/,/g, ""));
    }

    updatedList[index][field] = parsed || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(numericValue);

    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };

  // SET AR
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = async (arSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        arID: arSelected.AR_Id,
        arCode: arSelected.AR_Code,
        arName: arSelected.AR_Name,
        arAdd1: arSelected.AR_Add1,
        arAdd2: arSelected.AR_Add2,
        arAdd3: arSelected.AR_Add3,
        arProvince: arSelected.AR_Province,
        arZipcode: arSelected.AR_Zipcode,
        arTaxNo: arSelected.AR_TaxNo,
        saleman: arSelected.AR_RefSaleName,
        phone: arSelected.AR_RefSalePhone,
      });

      const arContact_list = await getData(
        "Tb_Set_ARContact",
        `ar_id = ${arSelected.AR_Id}`
      );
      if (arContact_list.length > 0) {
        const mapped = arContact_list.map((item) => ({
          id: item.id,
          contactName: item.contact_name,
          contactEmail: item.contact_email,
          contactPhone: item.contact_telephone,
        }));

        setARContactlist(mapped);

        // 3. เซ็ตผู้ติดต่อคนแรกอัตโนมัติ
        const firstContact = mapped[0];
        setContactID(firstContact.id);
        setFormMasterList((prev) => ({
          ...prev,
          contact_name: firstContact.contactName,
          contact_telephone: firstContact.contactPhone,
          contact_email: firstContact.contactEmail,
        }));
      } else {
        // ถ้าไม่มี contact เลย
        setARContactlist([]);
        setContactID(null);
        setFormMasterList((prev) => ({
          ...prev,
          contact_name: "",
          contact_telephone: "",
          contact_email: "",
        }));
      }
      handleArClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const idiemDataListRef = useRef([]);

  const onRowSelectItem = async (itemsSelected) => {
    console.log(1);
    try {
      const whId = whid;
      const itemsWithStock = [];
      const existingIds = new Set(formDetailList.map((item) => item.itemId));

      // กรองรายการที่ยังไม่มีอยู่
      const validItems = itemsSelected.filter(item => !existingIds.has(item.Item_Id));

      if (validItems.length === 0) {
        handleItemClose();
        return;
      }

      // ขั้นตอนที่ 1: ตรวจสอบ BOM สำหรับทุก items พร้อมกัน
      const bomChecks = await Promise.all(
        validItems.map(async (item) => {
          let showBom = false;
          if (item.Is_BOM === "Y") {
            const result = await Swal.fire({
              html: `
    <p style="margin-top: 10px; font-size:16px; line-height:1.6;">
          คุณต้องการแสดงรายการวัตถุดิบย่อย (BOM) สำหรับสินค้านี้หรือไม่?
          <br>
      <span style="color: #2c3e50; font-weight: bold;">${item.Item_Name}</span>
    </p>
  `,
              icon: "",
              showCancelButton: true,
              confirmButtonText: "แสดง BOM",
              cancelButtonText: "ไม่แสดง BOM",
              focusConfirm: false,
            });
            showBom = result.isConfirmed;
          }
          return { item, showBom };
        })
      );

      // ขั้นตอนที่ 2: โหลด on-hand data สำหรับ items หลักทั้งหมดพร้อมกัน
      const mainItemOnHandPromises = validItems.map(item =>
        fetchOnHand(whId, item.Item_Id)
      );
      const mainItemOnHandResults = await Promise.all(mainItemOnHandPromises);

      // ขั้นตอนที่ 3: สร้าง items หลักและเก็บข้อมูล BOM ที่ต้องโหลด
      const allBomItems = [];

      bomChecks.forEach(({ item, showBom }, index) => {
        const itemId = item.Item_Id;
        const isBOM = item.Is_BOM === "Y";

        const onHand = mainItemOnHandResults[index] || 0;

        // ➕ เพิ่มตัวหลัก
        itemsWithStock.push({
          line: null,
          itemId,
          itemCode: item.Item_Code,
          itemName: item.Item_Name,
          itemQty: formatCurrency(0),
          itemUnit: item.Item_Unit_ST,
          itemPriceUnit: formatCurrency(item.Item_Price || 0),
          itemDiscount: formatCurrency(0),
          itemDisType: "1",
          itemTotal: 0,
          itemStatus: item.Item_Status,
          whId,
          whName: item.WH_Name,
          zoneId: null,
          ltId: null,
          dsSeq: null,
          itemOnHand: onHand,
          isProjectItem: isBOM,
          parentId: null,
        });
        existingIds.add(itemId);

        // ➕ เพิ่ม Spec แถวพิเศษถ้ามี
        if (item.Is_Spec_Show === "Y" && item.Item_Spec) {
          itemsWithStock.push({
            line: null,
            itemId: null,
            itemCode: "",
            itemName: item.Item_Spec,
            itemQty: "",
            itemUnit: "",
            itemPriceUnit: "",
            itemDiscount: "",
            itemDisType: "",
            itemTotal: "",
            itemStatus: "",
            whId: "",
            whName: "",
            zoneId: null,
            ltId: null,
            dsSeq: null,
            itemOnHand: "",
            isSpecRow: true,
            parentId: itemId,
          });
        }

        // เก็บข้อมูล BOM สำหรับโหลดในขั้นตอนถัดไป
        if (isBOM && showBom) {
          allBomItems.push({ itemId, parentItem: item });
        }
      });

      // ขั้นตอนที่ 4: โหลดข้อมูล BOM ทั้งหมดพร้อมกัน
      if (allBomItems.length > 0) {
        const bomListPromises = allBomItems.map(({ itemId }) =>
          fetchBOMList(itemId)
        );

        const bomListResults = await Promise.all(bomListPromises);

        // รวบรวม BOM items ทั้งหมดสำหรับโหลด on-hand data
        const allBomOnHandPromises = [];
        const bomItemMappings = [];

        bomListResults.forEach((bomList, parentIndex) => {
          if (Array.isArray(bomList)) {
            const validBomItems = bomList.filter(bom => !existingIds.has(bom.item_id));

            validBomItems.forEach(bom => {
              allBomOnHandPromises.push(
                fetchOnHand(whId, bom.item_id)
              );
              bomItemMappings.push({
                bom,
                parentItemId: allBomItems[parentIndex].itemId
              });
            });
          }
        });

        // โหลด BOM on-hand data ทั้งหมดพร้อมกัน
        if (allBomOnHandPromises.length > 0) {
          const bomOnHandResults = await Promise.all(allBomOnHandPromises);

          // สร้าง BOM items
          bomItemMappings.forEach(({ bom, parentItemId }, index) => {
            const bomItemId = bom.item_id;
            const bomOnHand = bomOnHandResults[index] || 0;

            const matchedItem = itemDataList.find(itm => itm.Item_Id === bomItemId);
            const itemName = matchedItem?.Item_Name || "";
            const itemUnit = matchedItem?.Item_Unit_IN || "";

            itemsWithStock.push({
              line: null,
              itemId: bomItemId,
              itemCode: "BOM",
              itemName,
              itemQty: formatCurrency(bom.quantity || 0),
              itemUnit,
              itemPriceUnit: formatCurrency(0),
              itemDiscount: formatCurrency(0),
              itemDisType: "1",
              itemTotal: 0,
              itemStatus: "Y",
              whId,
              whName: "",
              zoneId: null,
              ltId: null,
              dsSeq: null,
              itemOnHand: bomOnHand,
              isProjectItem: false,
              isBOMChild: true,
              parentId: parentItemId,
            });
            existingIds.add(bomItemId);
          });
        }
      }

      // ➕ Merge รายการใหม่เข้ากับรายการเดิม
      setFormDetailList((prev) => [...prev, ...itemsWithStock]);

      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาด");
    }
  };

  const onRowSelectItem02 = () => {
    console.log(2);
    try {
      const emptyItem = {
        line: null,
        itemId: 1,
        itemCode: null,
        itemName: null,
        itemQty: formatCurrency(0),
        itemUnit: "",
        itemPriceUnit: formatCurrency(0),
        itemDiscount: formatCurrency(0),
        itemDisType: "1",
        itemTotal: 0,
        itemStatus: "Y",
        whId: null,
        whName: "",
        zoneId: null,
        ltId: null,
        dsSeq: null,
      };

      // ✅ ใช้ prev state เพื่อป้องกันค่าหาย
      setFormDetailList((prev) => [...prev, emptyItem]);

      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาด");
    }
  };

  // จัดระเบียบฟังก์ชัน onRowSelectItemForEdit - ปรับปรุงให้ทำงานเหมือน onRowSelectItem
  const onRowSelectItemForEdit = async (item, rowIndex) => {
    let bomItemIds = [];
    const existingRow = formDetailList[rowIndex];

    // ดึง BOM items ของรายการเดิม (ถ้ามี)
    if (existingRow && existingRow.itemId) {
      try {
        const bomList = await getDataWithComp(
          "Tb_Set_ItemBOM",
          `AND pro_id = ${existingRow.itemId}`
        );
        if (bomList && bomList.length > 0) {
          bomItemIds = bomList.map((b) => parseInt(b.item_id));
        }
      } catch (error) {
        getAlert("FAILED", "เกิดข้อผิดพลาดในการดึงข้อมูล BOM");
        return;
      }
    }

    try {
      const itemId = item.Item_Id;
      const isBOM = item.Is_BOM === "Y";
      const whId = whid;

      let showBom = false;
      if (isBOM) {
        const result = await Swal.fire({
          html: `
    <p style="margin-top: 10px; font-size:16px; line-height:1.6;">
          คุณต้องการแสดงรายการวัตถุดิบย่อย (BOM) สำหรับสินค้านี้หรือไม่?
          <br>
      <span style="color: #2c3e50; font-weight: bold;">${item.Item_Name}</span>

    </p>
  `,
          icon: "",
          showCancelButton: true,
          confirmButtonText: "แสดง BOM",
          cancelButtonText: "ไม่แสดง BOM",
          focusConfirm: false,
        });
        showBom = result.isConfirmed;
      }

      const onHand = await fetchOnHand(whId, itemId);

      // สร้างรายการใหม่ทั้งหมดที่จะเพิ่มเข้าไป
      const itemsToAdd = [];

      // ➕ เพิ่มตัวหลัก
      itemsToAdd.push({
        line: null,
        itemId,
        itemCode: item.Item_Code,
        itemName: item.Item_Name,
        itemQty: formatCurrency(1),
        itemUnit: item.Item_Unit_ST,
        itemPriceUnit: formatCurrency(item.Item_Price || 0),
        itemDiscount: formatCurrency(0),
        itemDisType: "1",
        itemTotal: formatCurrency(item.Item_Price || 0),
        itemStatus: item.Item_Status,
        whId,
        whName: item.WH_Name,
        zoneId: null,
        ltId: null,
        dsSeq: null,
        itemOnHand: onHand,
        isProjectItem: isBOM,
        parentId: null,
      });

      // ➕ เพิ่ม Spec แถวพิเศษถ้ามี
      if (item.Is_Spec_Show === "Y" && item.Item_Spec) {
        itemsToAdd.push({
          line: null,
          itemId: null,
          itemCode: "",
          itemName: item.Item_Spec,
          itemQty: "",
          itemUnit: "",
          itemPriceUnit: "",
          itemDiscount: "",
          itemDisType: "",
          itemTotal: "",
          itemStatus: "",
          whId: "",
          whName: "",
          zoneId: null,
          ltId: null,
          dsSeq: null,
          itemOnHand: "",
          isSpecRow: true,
          parentId: itemId, // เพิ่ม parentId เหมือน BOM children
        });
      }

      // ➕ เพิ่ม BOM ลูกถ้ามี (ใช้ parallel loading สำหรับ on-hand data)
      if (isBOM && showBom) {
        const bomList = await fetchBOMList(itemId);

        if (Array.isArray(bomList) && bomList.length > 0) {
          // Load on-hand data ทั้งหมดพร้อมกัน
          const bomOnHandPromises = bomList.map(bom =>
            fetchOnHand(whId, bom.item_id)
          );

          const bomOnHandResults = await Promise.all(bomOnHandPromises);

          // สร้าง items ใหม่
          bomList.forEach((bom, index) => {
            const bomItemId = bom.item_id;
            const bomOnHand = bomOnHandResults[index] || 0;

            const matchedItem = itemDataList.find(
              (itm) => itm.Item_Id === bomItemId
            );
            const itemName = matchedItem?.Item_Name || "";
            const itemUnit = matchedItem?.Item_Unit_IN || "";

            itemsToAdd.push({
              line: null,
              itemId: bomItemId,
              itemCode: "BOM",
              itemName,
              itemQty: formatCurrency(bom.quantity || 0),
              itemUnit,
              itemPriceUnit: formatCurrency(0),
              itemDiscount: formatCurrency(0),
              itemDisType: "1",
              itemTotal: 0,
              itemStatus: "Y",
              whId,
              whName: "",
              zoneId: null,
              ltId: null,
              dsSeq: null,
              itemOnHand: bomOnHand,
              isProjectItem: false,
              isBOMChild: true,
              parentId: itemId,
            });
          });
        }
      }

      setFormDetailList((prevList) => {
        const newList = [];

        // เพิ่มรายการก่อนหน้า rowIndex
        for (let i = 0; i < rowIndex; i++) {
          newList.push(prevList[i]);
        }

        // เพิ่มรายการใหม่ทั้งหมด
        itemsToAdd.forEach((item) => {
          newList.push(item);
        });

        // เพิ่มรายการหลัง rowIndex โดยข้าม BOM children และ Spec row ของรายการเก่า
        for (let i = rowIndex + 1; i < prevList.length; i++) {
          const currentItem = prevList[i];

          // ข้าม BOM children ของรายการเก่า
          const isBOMChildOfOldItem =
            (currentItem.itemCode === "BOM" ||
              (!currentItem.itemCode &&
                parseCurrency(currentItem.itemPriceUnit) === 0)) &&
            parseInt(currentItem.parentId) === parseInt(existingRow?.itemId) &&
            (bomItemIds.includes(parseInt(currentItem.itemId)) ||
              currentItem.isBOMChild === true);

          if (isBOMChildOfOldItem) {
            continue;
          }

          // ข้าม Spec row ของรายการเก่า - ตรวจสอบทั้ง boolean และ string
          const isSpecRow =
            currentItem.isSpecRow === true ||
            (typeof currentItem.isSpecRow === "string" &&
              currentItem.isSpecRow.length > 0) ||
            (!currentItem.itemCode &&
              !currentItem.itemId &&
              currentItem.itemName &&
              !currentItem.isBOMChild);

          console.log("Debug Spec Row Details:", {
            currentItem: {
              itemName: currentItem.itemName,
              itemCode: currentItem.itemCode,
              itemId: currentItem.itemId,
              isSpecRow: currentItem.isSpecRow,
              isBOMChild: currentItem.isBOMChild,
              parentId: currentItem.parentId,
            },
            computed: {
              isSpecRow,
              existingRowItemId: existingRow?.itemId,
              parentIdMatch:
                parseInt(currentItem.parentId) ===
                parseInt(existingRow?.itemId),
            },
          });

          const isSpecRowOfOldItem =
            isSpecRow &&
            parseInt(currentItem.parentId) === parseInt(existingRow?.itemId);

          if (isSpecRowOfOldItem) {
            continue;
          }

          newList.push(currentItem);
        }

        return newList;
      });
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาด");
    }
  };

  const handleDuplicateRow = (index) => {
    const newItem = { ...formDetailList[index] };
    const newList = [
      ...formDetailList.slice(0, index + 1),
      newItem,
      ...formDetailList.slice(index + 1),
    ];
    setFormDetailList(newList);
  };

  const handleRemoveRow = async (index) => {
    const rowToRemove = formDetailList[index];

    // ป้องกันการลบ BOM children และ Spec rows โดยตรง
    if (rowToRemove.isBOMChild && rowToRemove.itemId !== 1) {
      getAlert(
        "FAILED",
        "ไม่สามารถลบรายการ BOM ได้โดยตรง ต้องลบผ่านรายการหลัก"
      );
      return;
    }

    if (rowToRemove.isSpecRow && rowToRemove.itemId !== 1) {
      getAlert(
        "FAILED",
        "ไม่สามารถลบรายการ Spec ได้โดยตรง ต้องลบผ่านรายการหลัก"
      );
      return;
    }

    let newList = [...formDetailList];

    if (rowToRemove) {
      const parentId = rowToRemove.itemId;

      try {
        const bomList = await getDataWithComp(
          "Tb_Set_ItemBOM",
          `AND pro_id = ${parentId}`
        );

        const bomItemIds = bomList.map((bom) => parseInt(bom.item_id));

        newList = newList.filter((item, idx) => {
          // ข้าม index ที่จะลบ
          if (idx === index) return false;

          // ลบ BOM children ที่เป็นของ parent นี้
          const isBOMMatch =
            item.isBOMChild &&
            bomItemIds.includes(parseInt(item.itemId)) &&
            parseInt(item.parentId) === parseInt(parentId);

          // ลบ Spec row ที่เป็นของ parent นี้
          console.log("item", item);
          const isSpecRowMatch =
            item.isSpecRow && parseInt(item.parentId) === parseInt(parentId);

          // คืนค่า true ถ้าต้องการเก็บไว้, false ถ้าต้องการลบ
          return !isBOMMatch && !isSpecRowMatch;
        });

        setFormDetailList(newList);
      } catch (err) {
        getAlert("FAILED", "เกิดข้อผิดพลาดขณะลบ BOM");
      }

      return;
    }

    newList = newList.filter((item, idx) => {
      if (idx === index) return false;

      // ลบ Spec row ที่เป็นของรายการที่ลบ (เปรียบเทียบแบบ parseInt)
      if (
        item.isSpecRow &&
        parseInt(item.parentId) === parseInt(rowToRemove.itemId)
      )
        return false;

      return true;
    });

    setFormDetailList(newList);
  };

  const handleVatChange = () => {
    setIsVatChecked((prev) => !prev);
  };

  const contactOptions = [
    ...(formMasterList.contact_name &&
      !arContactlist.some(
        (c) =>
          c.contactName === formMasterList.contact_name &&
          c.contactPhone === formMasterList.contact_telephone &&
          c.contactEmail === formMasterList.contact_email
      )
      ? [
        {
          label: [
            formMasterList.contact_name,
            formMasterList.contact_telephone,
            formMasterList.contact_email,
          ]
            .filter(Boolean)
            .join(" | "),
          value: -1, // id ชั่วคราว
          contactName: formMasterList.contact_name,
          contactPhone: formMasterList.contact_telephone,
          contactEmail: formMasterList.contact_email,
        },
      ]
      : []),

    ...arContactlist.map((con) => ({
      label: [con.contactName, con.contactPhone, con.contactEmail]
        .filter(Boolean)
        .join(" | "),
      value: con.id,
      contactName: con.contactName,
      contactPhone: con.contactPhone,
      contactEmail: con.contactEmail,
    })),
  ];

  const SaveAS = async () => {
    const findMaxDocNo = await getData(
      "API_0601_QT_H",
      "1=1 ORDER BY Doc_ID DESC OFFSET 0 ROWS FETCH NEXT 1 ROWS ONLY"
    );
    const maxDoc = getMaxDocNo(findMaxDocNo, "QT");

    setFormMasterList((prev) => ({
      ...prev,
      docNo: maxDoc,
      docDate: formatThaiDateUi(moment()),
      docDueDate: formatThaiDateUi(moment()),
      createdDate: getCreateDateTime(),
      createdByName: window.localStorage.getItem("name") || "",
      createdById: window.localStorage.getItem("emp_id") || "",
      docStatus: 1,
      updateDate: "",
      updateByName: "",
      updateById: "",
      approvedDate: "",
      approvedByName: "",
      approvedById: "",
      cancelDate: "",
      cancelByName: "",
      cancelById: "",
      approvedMemo: "",
      printedStatus: "N",
      printedDate: "",
      printedBy: "",
    }));

    setMaxDocNo(maxDoc);
    setMode("I");
  };

  const handleShowReviseLog = async () => {
    if (!formMasterList.docNo) return;
    setShowReviseModal(true);
    await getData(
      "Tb_QT_H_Rev",
      `Doc_No = '${formMasterList.docNo}' ORDER BY Doc_Id DESC`
    )
      .then((data) => {
        setReviseLog(data);
      })
      .catch((error) => {
        getAlert("FAILED", error.message || "เกิดข้อผิดพลาดในการดึงข้อมูล");
      });
  };

  const handleDetailRevise = async (row) => {
    setShowDetailReviseModal(true);
    setDetailReviseHeader(null);
    setDetailReviseList([]);
    setShowReviseModal(false);
    try {
      const [originalQuotationHeader, originalQuotationDetails] =
        await Promise.all([
          getData("Tb_QT_H_Rev", `Doc_Id = '${row}'`),
          getData("Tb_QT_D_Rev", `Doc_ID = ${row}`),
        ]);
      setDetailReviseHeader(originalQuotationHeader[0]);
      setDetailReviseList(originalQuotationDetails);
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาดในการดึงข้อมูล");
    }
  };

  const handleRevise = async () => {
    if (editRevise && formMasterList.docId) {
      try {
        const updateHeaderData = {
          Doc_No: formMasterList.docNo,
          Doc_Date: formatStringDateToDate(formMasterList.docDate),
          Doc_DueDate: formatStringDateToDate(formMasterList.docDueDate),
          Doc_Status: parseInt(formMasterList.docStatus, 10),
          Doc_Code: parseInt(formMasterList.docCode, 10),
          Doc_Type: parseInt(formMasterList.docType, 10),
          Doc_For: parseInt(formMasterList.docFor, 10),
          Doc_Is_PRC: parseInt(formMasterList.docIsPO, 10),
          Ref_DocID: formMasterList.refDocID,
          Ref_Doc: formMasterList.refDoc,
          Ref_DocDate: formMasterList.refDocDate,
          Comp_Id: parseInt(formMasterList.compId, 10) || 3,
          Ref_ProjectID: formMasterList.refProjectID,
          Ref_ProjectNo: formMasterList.refProjectNo,
          Transport_Type: parseInt(formMasterList.transportType, 10),
          Doc_Remark1: formMasterList.docRemark1,
          Doc_Remark2: formMasterList.docRemark2,
          AR_ID: parseInt(formMasterList.arID, 10),
          AR_Code: formMasterList.arCode,
          Action_Hold: parseInt(formMasterList.actionHold, 10),
          Discount_Value: parseCurrency(formMasterList.discountValue || 0.0),
          Discount_Value_Type: parseInt(
            formMasterList.discountValueType || selectedDiscountValueType,
            10
          ),
          Discount_Cash: parseCurrency(formMasterList.discountCash || 0.0),
          Discount_Cash_Type: parseInt(formMasterList.discountCashType, 10),
          Discount_Transport: parseCurrency(
            formMasterList.discountTransport || 0.0
          ),
          Discount_Transport_Type: parseInt(
            formMasterList.discountTransportType,
            10
          ),
          IsVat: isVatChecked ? parseInt("1", 10) : parseInt("2", 10),
          Doc_SEQ: formMasterList.docSEQ,
          CreditTerm: parseInt(formMasterList.creditTerm, 10),
          CreditTerm1Day: parseInt(formMasterList.creditTerm1Day, 10) || 0,
          CreditTerm1Remark: formMasterList.creditTerm1Remark,
          CreditTerm2Remark: formMasterList.creditTerm2Remark,
          ACC_Code: formMasterList.accCode,
          EmpName: formMasterList.empName,
          Created_Date: formatThaiDateUiToDate(formMasterList.createdDate),
          Created_By_Name: formMasterList.createdByName,
          Created_By_Id: formMasterList.createdById,
          Update_Date: formatThaiDateUiToDate(getCreateDateTime()),
          Update_By_Name: window.localStorage.getItem("name"),
          Update_By_Id: window.localStorage.getItem("emp_id"),
          Approved_Date: formatThaiDateUiToDate(formMasterList.approvedDate),
          Approved_By_Name: formMasterList.approvedByName,
          Approved_By_Id: formMasterList.approvedById,
          Cancel_Date: formatThaiDateUiToDate(formMasterList.cancelDate),
          Cancel_By_Name: formMasterList.cancelByName,
          Cancel_By_Id: formMasterList.cancelById,
          Approved_Memo: formMasterList.approvedMemo,
          Printed_Status: formMasterList.printedStatus,
          Printed_Date: formatThaiDateUiToDate(formMasterList.printedDate),
          Printed_By: formMasterList.printedBy,
          Ref_SaleName: formMasterList.saleman,
          Ref_SalePhone: formMasterList.phone,
          Delivery_to: formMasterList.delivery,
          Validity_day: parseInt(formMasterList.validityDay, 10),
          Payment_text: formMasterList.payment,
          Contact_Name: formMasterList.contact_name,
          Contact_Telephone: formMasterList.contact_telephone,
          Contact_Email: formMasterList.contact_email,
          Payment_Text2: formMasterList.payment2,
          Doc_Rev: parseInt(formMasterList.Doc_Rev, 10),
          ref_cc: formMasterList.cc || "",
        };

        // update Header
        await updateData("Tb_QT_H_Rev", updateHeaderData, {
          Doc_Id: formMasterList.docId,
        });

        // เตรียมข้อมูล Detail สำหรับ update
        await deleteData(
          "Tb_QT_D_Rev",
          `Where Doc_ID = ${formMasterList.docId}`
        );
        await Promise.all(
          formDetailList.map((item, index) => {
            const detailRow = {
              Doc_ID: formMasterList.docId,
              Line: item.line || index + 1,
              Item_Id: item.itemId || null,
              Item_Code:
                item.itemCode === "BOM" || item.isSpecRow ? "" : item.itemCode,
              Item_Name: item.itemName || "ไม่ระบุ",
              Item_Qty: item.isSpecRow ? 0 : parseCurrency(item.itemQty),
              Item_Unit: item.isSpecRow ? "" : item.itemUnit || "-",
              Item_Price_Unit: item.isSpecRow
                ? 0
                : parseCurrency(item.itemPriceUnit),
              Item_Discount: item.isSpecRow
                ? 0
                : parseCurrency(item.itemDiscount),
              Item_DisType: item.isSpecRow
                ? 1
                : item.itemDisType === "1"
                  ? 1
                  : 2,
              Item_Total: item.isSpecRow
                ? 0
                : parseCurrency(
                  item.itemDisType === "2"
                    ? parseCurrency(item.itemQty) *
                    parseCurrency(item.itemPriceUnit) -
                    (parseCurrency(item.itemDiscount) / 100) *
                    (parseCurrency(item.itemQty) *
                      parseCurrency(item.itemPriceUnit))
                    : parseCurrency(item.itemQty) *
                    parseCurrency(item.itemPriceUnit) -
                    parseCurrency(item.itemDiscount)
                ),
              Item_Status: 1,
              DS_SEQ: formatDateTime(new Date()),
            };
            return insertData(
              "Tb_QT_D_Rev",
              Object.keys(detailRow).join(", "),
              Object.values(detailRow)
            );
          })
        );
        getAlert("OK", "อัปเดตการปรับปรุงเรียบร้อยแล้ว");
        setEditRevise(false);
        setMode("U");
        callInitialize();
      } catch (error) {
        getAlert("FAILED", error.message || "ไม่สามารถอัปเดตข้อมูลปรับปรุงได้");
      }
      return;
    }

    // ถ้าไม่ใช่โหมดแก้ไขปรับปรุง ให้บันทึกแบบ insert
    const quotationDocId = formMasterList.docId;

    let originalQuotationHeader = [];
    let originalQuotationDetails = [];
    let insertedDocId = null;

    try {
      [originalQuotationHeader, originalQuotationDetails] = await Promise.all([
        getData("QT_H", `Doc_ID = ${quotationDocId}`),
        getData("QT_D", `Doc_ID = ${quotationDocId}`),
      ]);
    } catch (error) {
      return getAlert("FAILED", "ดึงข้อมูลต้นฉบับไม่สำเร็จ");
    }

    try {
      const updatedHeader = {
        ...originalQuotationHeader[0],
        Update_Date: formatThaiDateUiToDate(getCreateDateTime()),
        Update_By_Name: window.localStorage.getItem("name"),
        Update_By_Id: window.localStorage.getItem("emp_id"),
        // Doc_Rev: (originalQuotationHeader[0].Doc_Rev || 0) + 1,
      };

      const { Doc_Id, ...headerData } = updatedHeader;

      const insertedHeader = await insertData(
        "Tb_QT_H_Rev",
        Object.keys(headerData).join(", "),
        Object.values(headerData)
      );

      insertedDocId = insertedHeader?.result?.recordset?.[0]?.insertedId;

      if (!insertedDocId) throw new Error("ไม่สามารถบันทึก Header ได้");
    } catch (error) {
      return getAlert("FAILED", "บันทึก Header ไม่สำเร็จ");
    }

    try {
      const detailRecords = originalQuotationDetails.map(
        ({ DT_Id, ...rest }) => ({
          ...rest,
          Doc_ID: insertedDocId,
        })
      );

      await Promise.all(
        detailRecords.map((row) =>
          insertData(
            "Tb_QT_D_Rev",
            Object.keys(row).join(", "),
            Object.values(row)
          )
        )
      );
    } catch (error) {
      return getAlert("FAILED", "บันทึกรายการสินค้าไม่สำเร็จ");
    }

    try {
      await handleUpdate();
      getAlert("SUCCESS", "บันทึกการปรับปรุงเรียบร้อยแล้ว");
    } catch (error) {
      return getAlert("FAILED", "ไม่สามารถอัปเดตสถานะเอกสารต้นฉบับได้");
    }
  };

  // อัปเดตข้อมูลใน Tb_QT_H_Rev และ Tb_QT_D_Rev ตาม row ที่เลือก
  const handleEditRevise = async (row) => {
    setFormDetailList([]);
    setFormMasterList([]);
    try {
      if (!row) {
        return getAlert("FAILED", "ไม่พบข้อมูล ID ของการปรับปรุงที่เลือก");
      }
      // ดึงข้อมูล revision
      const [selectedRevise, revisionDetails] = await Promise.all([
        getData("Tb_QT_H_Rev", `Doc_Id = ${row}`),
        getData("Tb_QT_D_Rev", `Doc_ID = ${row}`),
      ]);
      if (!selectedRevise || selectedRevise.length === 0) {
        return getAlert("FAILED", "ไม่พบข้อมูลการปรับปรุงที่เลือก");
      }
      const h = selectedRevise[0];
      // เตรียมข้อมูลผู้ติดต่อ
      let arContactList = [];
      if (h.AR_ID) {
        try {
          const arContactRaw = await getData(
            "Tb_Set_ARContact",
            `ar_id = ${h.AR_ID}`
          );
          arContactList = arContactRaw.map((item) => ({
            id: item.id,
            contactName: item.contact_name,
            contactEmail: item.contact_email,
            contactPhone: item.contact_telephone,
          }));
        } catch (e) {
          arContactList = [];
        }
      }
      setARContactlist(arContactList);
      let arMaster = null;
      if (Array.isArray(arDataList) && (h.AR_Code || h.AR_Id)) {
        arMaster = arDataList.find(
          (ar) => ar.AR_Code === h.AR_Code || ar.AR_Id === h.AR_Id
        );
      }
      const customerData = {
        arName: h.AR_Name || arMaster?.AR_Name || "",
        arAdd1: h.AR_Add1 || arMaster?.AR_Add1 || "",
        arAdd2: h.AR_Add2 || arMaster?.AR_Add2 || "",
        arAdd3: h.AR_Add3 || arMaster?.AR_Add3 || "",
        arProvince: h.AR_Province || arMaster?.AR_Province || "",
        arZipcode: h.AR_Zipcode || arMaster?.AR_Zipcode || "",
        arTaxNo: h.AR_TaxNo || arMaster?.AR_TaxNo || "",
        saleman:
          h.Saleman || h.AR_RefSaleName || arMaster?.AR_RefSaleName || "",
        phone: h.Phone || h.AR_RefSalePhone || arMaster?.AR_RefSalePhone || "",
      };
      // map ข้อมูลหลักให้ตรงกับ state ที่ UI ใช้
      setFormMasterList((prev) => ({
        ...prev,
        docId: h.Doc_Id,
        docNo: h.Doc_No,
        docDate: formatThaiDateUi(h.Doc_Date),
        docDueDate: formatThaiDateUi(h.Doc_DueDate),
        docStatus: h.Doc_Status,
        arID: h.AR_ID,
        arCode: h.AR_Code,
        ...customerData,
        contact_name: h.Contact_Name || h.contact_name || "",
        contact_telephone: h.Contact_Telephone || h.contact_telephone || "",
        contact_email: h.Contact_Email || h.contact_email || "",
        validityDay: h.Validity_day || h.ValidityDay || "",
        delivery: h.Delivery_to || h.Delivery || "",
        payment: h.Payment_text || h.Payment || "",
        payment2: h.Payment2_text || h.Payment2 || "",
        docRemark1: h.Doc_Remark1 || "",
        docRemark2: h.Doc_Remark2 || "",
        createdDate:
          setCreateDateTime(h.Created_Date) || formatThaiDateUi(new Date()),
        createdByName: h.Created_By_Name || "",
        createdById: h.Created_By_Id || "",
        updateDate: setCreateDateTime(h.Update_Date) || "",
        updateByName: h.Update_By_Name || "",
        updateById: h.Update_By_Id || "",
        approvedDate: setCreateDateTime(h.Approved_Date) || "",
        approvedByName: h.Approved_By_Name || "",
        approvedById: h.Approved_By_Id || "",
        cancelDate: setCreateDateTime(h.Cancel_Date) || "",
        cancelByName: h.Cancel_By_Name || "",
        cancelById: h.Cancel_By_Id || "",
        approvedMemo: h.Approved_Memo || "",
        printedStatus: h.Printed_Status || "",
        printedDate: setCreateDateTime(h.Printed_Date) || "",
        printedBy: h.Printed_By || "",
        docType: h.Doc_Type || "",
        transportType: h.Transport_Type || "",
        discountValue: h.Discount_Value,
        discountValueType: h.Discount_Value_Type,
        Doc_Rev: h.Doc_Rev || 0,
        cc: h.Ref_CC || "",
      }));

      // map รายการสินค้า
      setFormDetailList(
        (revisionDetails || []).map((item) => ({
          line: item.DT_Line,
          itemId: item.Item_Id,
          itemCode: item.Item_Code || "",
          isProjectItem: item.Is_Project_Item === "Y",
          itemOnHand: item.Item_Onhand || 0,
          itemUnit: item.Item_Unit_ST || item.Item_Unit || "",
          whId: item.WH_Id,
          whName: item.WH_Name || "",
          zoneId: item.Zone_Id,
          ltId: item.LT_Id,
          dsSeq: item.DS_Seq,
          itemStatus: item.Item_Status || "Y",
          parentId: item.Parent_Id,
          itemDisType: item.Item_Dis_Type || "1",
          isBOMChild: item.Is_BOM_Child === "Y",
          isSpecRow: item.Is_Spec_Row === "Y",
          itemName: item.Item_Name || "",
          itemQty: formatCurrency(item.Item_Qty || 0),
          itemPriceUnit: formatCurrency(item.Item_Price_Unit || 0),
          itemDiscount: formatCurrency(item.Item_Discount || 0),
          itemTotal: formatCurrency(item.Item_Total || 0),
        }))
      );
      // ตั้งค่าผู้ติดต่ออัตโนมัติถ้าตรง
      if (arContactList.length > 0) {
        let found = arContactList.find(
          (c) => c.contactName === (h.Contact_Name || h.contact_name)
        );
        setContactID(found ? found.id : null);
      } else {
        setContactID(null);
      }
      setShowDetailReviseModal(false);
      setEditRevise(true);
      getAlert(
        "OK",
        `ดึงข้อมูลการปรับปรุงครั้งที่ ${h.Doc_Rev || 0} เรียบร้อยแล้ว`
      );
    } catch (error) {
      console.error("Error in handleEditRevise:", error);
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาดในการปรับปรุงข้อมูล");
    }
  };

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      mode !== "U" &&
      !contactID &&
      arContactlist.length > 0 &&
      !formMasterList.contact_name
    ) {
      const firstContact = arContactlist[0];
      setContactID(firstContact.id);
      setFormMasterList((prev) => ({
        ...prev,
        contact_name: firstContact.contactName,
        contact_telephone: firstContact.contactPhone,
        contact_email: firstContact.contactEmail,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arContactlist]);

  useEffect(() => {
    if (contactID && arContactlist.length > 0) {
      const selected = arContactlist.find((c) => c.id === contactID);
      if (selected) {
        setFormMasterList((prev) => ({
          ...prev,
          contact_name: selected.contactName,
          contact_telephone: selected.contactPhone,
          contact_email: selected.contactEmail,
        }));
      }
    }
  }, [contactID, arContactlist]);
  // การคำนวณยอดรวม (totalPrice)
  useEffect(() => {
    const total = formDetailList.reduce(
      (acc, item) => acc + (parseCurrency(item.itemTotal) || 0),
      0
    );
    setTotalPrice(total);
  }, [formDetailList]);

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    let discountValue = parseCurrency(formMasterList.discountValue || 0);
    let receiptDiscount = 0;

    if (selectedDiscountValueType === "2") {
      // เปอร์เซ็นต์
      receiptDiscount = (totalPrice / 100) * discountValue;
    } else if (selectedDiscountValueType === "1") {
      // จำนวนเงิน
      receiptDiscount = discountValue;
    }

    setReceiptDiscount(receiptDiscount);
  }, [totalPrice, formMasterList.discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    const vat = isVatChecked ? subFinal * 0.07 : 0;
    setVatAmount(parseCurrency(vat.toFixed(2)));
  }, [subFinal, isVatChecked]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const grandTotal = subFinal + vatAmount;
    setGrandTotal(parseCurrency(grandTotal));
  }, [subFinal, vatAmount]);

  useEffect(() => {
    setFormMasterList((prev) => ({
      ...prev,
      discountValueType: selectedDiscountValueType,
    }));
  }, [selectedDiscountValueType]);

  useEffect(() => {
    // เรียกใช้ getViewItem  เพิ่มSetitemDatalist อีกครั้งเมื่อ showItemModal
    if (showItemModal) {
      getViewItem().then((data) => {
        idiemDataListRef.current = data;
        setItemDataList(data);
      });
    }
  }, [showItemModal]);

  const fetchOnHand = async (whIdParam, itemIdParam) => {
    const key = `${parseCurrency(whIdParam)}:${parseCurrency(itemIdParam)}`;
    if (onHandCacheRef.current.has(key)) return onHandCacheRef.current.get(key);
    const res = await getDataWithComp(
      "API_1101_WH_ITEM_ONHAND",
      `AND WH_Id = ${parseCurrency(whIdParam)} AND Item_Id = ${parseCurrency(itemIdParam)}`
    );
    const value = Array.isArray(res) && res[0] ? parseCurrency(res[0].Item_Onhand) : 0;
    onHandCacheRef.current.set(key, value);
    return value;
  };

  const fetchBOMList = async (parentId) => {
    const key = String(parentId);
    if (bomListCacheRef.current.has(key)) return bomListCacheRef.current.get(key);
    const list = await getDataWithComp("Tb_Set_ItemBOM", `AND pro_id = ${parseCurrency(parentId)}`);
    const safe = Array.isArray(list) ? list : [];
    bomListCacheRef.current.set(key, safe);
    return safe;
  };

  return (
    <>
      <Breadcrumbs
        page={
          (mode === "R"
            ? maxDocNo + " Rev." + ((formMasterList.Doc_Rev || 0) + 1)
            : mode === "U" && formMasterList.Doc_Rev > 0
              ? maxDocNo + " Rev." + formMasterList.Doc_Rev
              : maxDocNo) + (editRevise ? " (EDIT Revise)" : "")
        }
        isShowStatus={mode === "U" || mode === "R"}
        statusName={statusName}
        statusColour={statusColour}
        items={[
          { name: "ขายสินค้า", url: "/sellproducts" },
          { name: name, url: "/quotation" },
          // ถ้า U เรียกดู ถ้า R (revise) ปรับปรุง (I) สร้าง
          {
            name:
              mode === "U"
                ? "เรียกดู" + name
                : mode === "R"
                  ? "ปรับปรุง" + name
                  : "สร้าง" + name,
            url: "#",
          },
        ]}
        onHandleClick={() => getReport("qt", formMasterList.docNo)}
        Revise={handleShowReviseLog}
        SaveAS={SaveAS}
        mode={mode}
      />

      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(255, 255, 255, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
          }}
        >
          <div
            className="spinner-border"
            role="status"
            aria-live="polite"
            aria-busy="true"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <div
        className="hidden-scrollbar"
        style={{ maxHeight: "80vh", overflowY: "auto" }}
      >
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วันที่เอกสาร</label>
              <Datetime
                className="input-spacing-input-date"
                name="docDate"
                value={formMasterList.docDate || null}
                onChange={(date) => handleChangeDateMaster(date, "docDate")}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{ readOnly: true, disabled: mode === "U" }}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ลูกค้า</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="arCode"
                  value={
                    (formMasterList.arCode || "") +
                    " " +
                    (formMasterList.arName || "")
                  }
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleArShow}
                  disabled={
                    formMasterList.docStatus === 1 || mode === "U"
                      ? false
                      : true
                  }
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <ArModal
              showArModal={showArModal}
              handleArClose={handleArClose}
              arDataList={arDataList}
              onRowSelectAr={onRowSelectAr}
            />
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdDate"
                value={formMasterList.createdDate}
                // onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>อ้างอิงเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="refDoc"
                value={formMasterList.refDoc || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ที่อยู่</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="arAdd1"
                value={formMasterList.arAdd1 || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdByName"
                value={formMasterList.createdByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วันที่เอกสารอ้างอิง</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="refDocDate"
                value={formMasterList.refDocDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.arAdd2 || "") +
                  " " +
                  (formMasterList.arAdd3 || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formMasterList.updateDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>ประเภทเอกสาร</label>
              <select
                className="form-select form-control input-spacing"
                name="docType"
                value={formMasterList.docType}
                onChange={handleChangeMaster}
                disabled={formMasterList.docStatus !== 1}
              >
                {tbDocType.map((docType) => (
                  <option key={docType.DocType_Id} value={docType.DocType_Id}>
                    {docType.DocType_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.arProvince || "") +
                  " " +
                  (formMasterList.arZipcode || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้แก้ไขเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateByName"
                value={formMasterList.updateByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วิธีจัดส่ง</label>
              <select
                name="transportType"
                value={formMasterList.transportType}
                onChange={handleChangeMaster}
                className="form-select form-control input-spacing"
                disabled={formMasterList.docStatus !== 1}
              >
                {tbTransType.map((transType) => (
                  <option
                    key={transType.Trans_TypeID}
                    value={transType.Trans_TypeID}
                  >
                    {transType.Trans_TypeName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>เลขที่ภาษี</label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.arTaxNo || ""}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>Delivery</label>
              {/* <input
                type="text"
                className="form-control input-spacing"
                name="delivery"
                value={formMasterList.delivery || ""}
                onChange={handleChangeMaster}
                // disabled={true}
              /> */}
              <textarea
                type="text"
                className="form-control input-spacing"
                name="delivery"
                value={formMasterList.delivery || ""}
                onChange={handleChangeMaster}
                maxLength={255}
              // disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>Due Date</label>
              <Datetime
                className="input-spacing-input-date"
                name="docDueDate"
                value={formMasterList.docDueDate || null}
                onChange={(date) => handleChangeDateMaster(date, "docDueDate")}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{
                  readOnly: true,
                  disabled: formMasterList.docStatus === 1 ? false : true,
                }}
              />
            </div>
          </div>
          <div className="col-4 ">
            <div className="d-flex align-items-center">
              <label>Saleman</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="Saleman"
                value={formMasterList.saleman || ""}
                // onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>Validity Day</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="validityDay"
                value={formMasterList.validityDay || ""}
                onChange={handleChangeMaster}
              // disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>ผู้ติดต่อ</label>
              <Select
                name="doc_contact"
                className="react-select"
                options={contactOptions}
                value={
                  contactOptions.find((opt) => opt.value === contactID) || null
                }
                menuPortalTarget={
                  typeof document !== "undefined" ? document.body : null
                }
                menuPosition="fixed"
                menuPlacement="auto"
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (base) => ({ ...base, zIndex: 9999 }),
                }}
                onChange={(selected) => {
                  if (selected) {
                    setContactID(selected.value); // อัปเดต contactID

                    setFormMasterList((prev) => ({
                      ...prev,
                      contact_name: selected.contactName,
                      contact_telephone: selected.contactPhone,
                      contact_email: selected.contactEmail,
                    }));
                  } else {
                    setContactID(null);
                    setFormMasterList((prev) => ({
                      ...prev,
                      contact_name: "",
                      contact_telephone: "",
                      contact_email: "",
                    }));
                  }
                }}
                placeholder="เลือกผู้ติดต่อ"
                isClearable
                isSearchable
              />
            </div>
          </div>

          <div className="col-4 ">
            <div className="d-flex align-items-center">
              <label>Phone</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="Phone"
                value={formMasterList.phone || ""}
                // onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label
                style={{
                  alignSelf: "self-start",
                  marginTop: "15px",
                }}
              >
                Payment
              </label>
              <div className="w-100">
                <input
                  type="text"
                  className="form-control input-spacing w-100 my-1"
                  name="payment"
                  value={formMasterList.payment || ""}
                  onChange={handleChangeMaster}
                // disabled={true}
                />
                {/* <input
                  type="text"
                  className="form-control input-spacing w-100"
                  name="payment2"
                  value={formMasterList.payment2 || ""}
                  onChange={handleChangeMaster}
                // disabled={true}
                /> */}
              </div>

              {/* <textarea
                type="text"
                className="form-control input-spacing"
                name="payment"
                value={formMasterList.payment || ""}
                onChange={handleChangeMaster}
                maxLength={255}
                // disabled={true}
              /> */}
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>CC.</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="cc"
                  value={formMasterList.cc || ""}
                  onChange={handleChangeMaster}
                // disabled={true}
                />
              </div>
            </div>
          </div>
          <div className="col-6"></div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label
                style={{
                  alignSelf: "self-start",
                  marginTop: "15px",
                }}
              ></label>
              <div className="w-100">
                <input
                  type="text"
                  className="form-control input-spacing w-100 my-1"
                  name="payment2"
                  value={formMasterList.payment2 || ""}
                  onChange={handleChangeMaster}
                />
              </div>
            </div>
          </div>
        </div>

        <hr />
        <div className="row mt-2">
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>รายละเอียดเอกสาร</label>
              {/* <input
                type="text"
                className="form-control input-spacing"
                name="docRemark1"
                value={formMasterList.docRemark1 || ""}
                onChange={handleChangeMaster}
                maxLength={100}
                // disabled={formMasterList.docStatus !== 1}
              /> */}

              <textarea
                type="text"
                className=" input-spacing"
                name="docRemark1"
                value={formMasterList.docRemark1 || ""}
                onChange={handleChangeMaster}
                style={{ height: "65px" }}
              // disabled={true}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>หมายเหตุธุรการ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark2"
                value={formMasterList.docRemark2 || ""}
                onChange={handleChangeMaster}

              // disabled={formMasterList.docStatus !== 1}
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <ItemTable
            formDetailList={formDetailList}
            setFormDetailList={setFormDetailList}
            handleChangeDetail={handleChangeDetail}
            handleDuplicateRow={handleDuplicateRow}
            handleRemoveRow={handleRemoveRow}
            formatCurrency={formatCurrency}
            showItemModal={showItemModal}
            handleItemClose={handleItemClose}
            itemDataList={itemDataList}
            onRowSelectItem={onRowSelectItem}
            onRowSelectItem02={onRowSelectItem02}
            handleItemShow={handleItemShow}
            whDataList={whDataList}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            disabled={
              formMasterList.docStatus !== 13 && formMasterList.docStatus !== 3
                ? false
                : true
            }
            onRowSelectItemForEdit={onRowSelectItemForEdit}
          />
          <Summary
            formMasterList={formMasterList}
            handleChangeMaster={handleChangeMaster}
            selectedDiscountValueType={selectedDiscountValueType}
            handleCheckboxChange={handleCheckboxChange}
            receiptDiscount={receiptDiscount}
            formatCurrency={formatCurrency}
            totalPrice={totalPrice}
            subFinal={subFinal}
            isVatChecked={isVatChecked}
            handleVatChange={handleVatChange}
            vatAmount={vatAmount}
            grandTotal={grandTotal}
            disabled={
              formMasterList.docStatus !== 13 && formMasterList.docStatus !== 3
                ? false
                : true
            }
          />
        </div>
      </div>

      <br />
      <FormAction
        onRevise={handleRevise}
        onSubmit={handleSubmit}
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        mode={mode}
        disabled={
          formMasterList.docStatus !== 13 && formMasterList.docStatus !== 3
            ? false
            : true
        }
        footer={true}
      />
      {showReviseModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1050,
          }}
        >
          <div
            className="modal-dialog modal-lg"
            role="document"
            style={{ marginTop: "100px" }}
          >
            <div className="modal-content shadow-lg rounded">
              <div
                className="modal-header"
                style={{
                  backgroundColor: "#EF6C00",
                  color: "white",
                }}
              >
                <h5 className="modal-title fw-bold">
                  ประวัติการปรับปรุงเอกสาร {formMasterList.docNo}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowReviseModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th className="text-center">ครั้งที่</th>
                      <th className="text-center">วันที่ปรับปรุง</th>
                      <th className="text-center">ผู้ปรับปรุง</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reviseLog.map((log, index) => (
                      <tr
                        key={index}
                        onClick={() => {
                          handleDetailRevise(log.Doc_Id);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <td className="text-center">
                          {log.Doc_Rev ? `REV.${log.Doc_Rev}` : "-"}
                        </td>{" "}
                        <td className="text-center">
                          {" "}
                          {setCreateDateTime(log.Update_Date) ||
                            formatThaiDateUi(new Date())}
                        </td>
                        <td className="text-center">{log.Update_By_Name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {showDetailReviseModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1050,
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
          }}
        >
          <div className="modal-dialog modal-xl" style={{ marginTop: "30px" }}>
            <div className="modal-content shadow-lg rounded">
              <div
                className="modal-header"
                style={{ backgroundColor: "#EF6C00", color: "white" }}
              >
                <h5 className="modal-title fw-bold">
                  รายละเอียดการปรับปรุงเอกสาร {formMasterList.docNo} ครั้งที่{" "}
                  {detailReviseHeader?.Doc_Rev || 0}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowDetailReviseModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                {/* Header Section */}
                {detailReviseHeader && (
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <p>
                        <strong>วันที่เอกสาร:</strong>{" "}
                        {formatThaiDateUi(detailReviseHeader.Doc_Date)}
                      </p>
                      {/* <p><strong>ลูกค้า:</strong> {detailReviseHeader.AR_Code} {detailReviseHeader.Customer_Name}</p>
                      <p><strong>ที่อยู่:</strong> {detailReviseHeader.Address}</p> */}
                      <p>
                        <strong>ผู้ติดต่อ:</strong>{" "}
                        {detailReviseHeader.Contact_Name}
                      </p>
                      <p>
                        <strong>Delivery:</strong>{" "}
                        {detailReviseHeader.Delivery_to}
                      </p>
                      <p>
                        <strong>Payment:</strong>{" "}
                        {detailReviseHeader.Payment_text}
                      </p>
                      <p>
                        <strong>รายละเอียดเอกสาร:</strong>{" "}
                        {detailReviseHeader.Doc_Remark1}
                      </p>
                    </div>
                    <div className="col-md-6">
                      {/* <p><strong>ผู้สร้างเอกสาร:</strong> {detailReviseHeader.Created_By_Name}</p> */}
                      <p>
                        <strong>ผู้ปรับปรุง:</strong>{" "}
                        {detailReviseHeader.Update_By_Name}
                      </p>
                      <p>
                        <strong>วันที่ปรับปรุง:</strong>{" "}
                        {formatThaiDateUi(detailReviseHeader.Update_Date)}
                      </p>
                      <p>
                        <strong>เวลาปรับปรุง:</strong>{" "}
                        {moment(detailReviseHeader.Update_Date)
                          .subtract(7, "hours")
                          .format("HH:mm:ss")}
                      </p>
                      <p>
                        <strong>หมายเหตุธุรการ:</strong>{" "}
                        {detailReviseHeader.Doc_Remark2}
                      </p>
                    </div>
                  </div>
                )}

                {/* Table Section */}
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead className="table-warning text-center">
                      <tr>
                        <th>#</th>
                        <th>รหัสสินค้า</th>
                        <th>ชื่อสินค้า</th>
                        <th>จำนวน</th>
                        <th>หน่วย</th>
                        <th>ราคาต่อหน่วย</th>
                        <th>ส่วนลด</th>
                        <th>%</th>
                        <th>จำนวนเงินรวม</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detailReviseList?.map((item, idx) => (
                        <tr key={idx}>
                          <td className="text-center">{idx + 1}</td>
                          <td>{item.Item_Code}</td>
                          <td>{item.Item_Name}</td>
                          <td className="text-end">
                            {item.Item_Qty.toFixed(2)}
                          </td>
                          <td>{item.Item_Unit}</td>
                          <td className="text-end">
                            {item.Item_Price_Unit.toLocaleString()}
                          </td>
                          <td className="text-end">
                            {item.Item_Discount?.toFixed(2)}
                          </td>
                          <td className="text-center">
                            {item.Item_DisType === 1 ? "%" : "฿"}
                          </td>
                          <td className="text-end">
                            {item.Item_Total.toLocaleString()}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="text-end mt-3">
                  <button
                    className="btn btn-primary text-white me-2"
                    onClick={() => getReport("QT_REV", formMasterList.docNo)}
                  >
                    <i className="fas fa-print"></i> พิมพ์
                  </button>
                  <button
                    className="btn btn-warning text-white"
                    onClick={() => handleEditRevise(detailReviseHeader.Doc_Id)}
                  >
                    <i className="fas fa-edit "></i> แก้ไข
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Form;
